import { render } from "./VideoCanvas.vue?vue&type=template&id=6b12657a&scoped=true"
import script from "./VideoCanvas.vue?vue&type=script&lang=js"
export * from "./VideoCanvas.vue?vue&type=script&lang=js"

import "./VideoCanvas.vue?vue&type=style&index=0&id=6b12657a&scoped=true&lang=css"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b12657a"]])

export default __exports__